import styled from 'styled-components'

import {
  Dropzone,
  DropzoneErrors,
  DropzoneFileNames,
  DropzonePreviews,
  TypeStyle,
} from '@syconium/little-miss-figgy'

import { NextLink } from '../../../../../../app/_components/navigation/NextLink'
import { Label } from '../../../primitives/shared-form-styles'

export const UploadField = styled.div`
  display: flex;
  flex-direction: column;
`

export const DigitizationHeader = styled(Label)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${o => o.theme.spacing(3)};
`

export const DigitizationPrice = styled(TypeStyle.HeadlineMicro)`
  font-weight: ${o => o.theme.typography.font.weight[700]};
`

export const DigitizationBlurb = styled(TypeStyle.BodySmall)`
  color: ${o => o.theme.color.text.secondary.on.background};
  margin-bottom: ${o => o.theme.spacing(3)};
`

export const LearnMoreLink = styled(NextLink)`
  color: inherit;
  text-decoration: underline;
`

export const DropzoneContainer = styled(Dropzone)<{ $hasFiles: boolean }>`
  width: 100%;
  padding: ${o => (o.$hasFiles ? '0' : `${o.theme.spacing(10, 0)}`)};
`

export const LogoPreview = styled(DropzonePreviews)`
  width: 100%;

  img {
    height: 156px;
    width: 156px;
    margin: 0 auto;
  }
`

/** The design system fixes the error list at the dropzone's default width, wider than a phone. */
export const UploadErrors = styled(DropzoneErrors)`
  width: 100%;
`

export const FileName = styled(DropzoneFileNames)`
  ${TypeStyle.css.bodyMicro}
  color: ${o => o.theme.color.text.secondary.on.background};
  margin-top: ${o => o.theme.spacing(2)};
  text-align: right;
`

export const UploadSpecs = styled(TypeStyle.BodyMicro)`
  color: ${o => o.theme.color.text.secondary.on.background};
  margin-top: ${o => o.theme.spacing(3)};
`
